const EMBEDDED = 'EMBEDDED'
const CHROME_EXTENSION = 'CHROME_EXTENSION'

export { EMBEDDED, CHROME_EXTENSION }
